<template>
  <div class="homePage">
    <div class="my-swipe">
      <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
        <van-swipe-item
          ><img src="../assets/images/banner.png" alt=""
        /></van-swipe-item>
        <van-swipe-item
          ><img src="../assets/images/banner.png" alt=""
        /></van-swipe-item>
      </van-swipe>
    </div>

    <div class="hot_wrapper">
      <!-- <div class="hot_wrapper_new">
        <h1>本周金句</h1>
        <p>只有当客户真正喜欢你相信你之后,才会开始购买你的产品。</p>
      </div> -->
    </div>

    <div class="card_list">
      <div class="item flex-between">
        <div class="card flex-rowc" @click="handleGo">
            <img src="../assets/images/signin_icon.png" alt="" />
            <div class="fontSize-mainColor-lg">每日签到</div>
          </div>
          <div class="card flex-rowc">
            <div class="left flex-rowc" @click="handleGo">
              <img src="../assets/images/edit_icon.png" />
              <div class="fontSize-mainColor-lg">工作日志</div>
            </div>
            <div class="isComplete">本日未填写</div>
          </div>
        <!-- <div class="left ">
          
          <div class="card flex-rowc" @click="handleGo(1)">
            <img src="../assets/images/business_icon.png" alt="" />
            <div class="fontSize-mainColor-lg">业务管理</div>
          </div>
        </div> -->
        <!-- <div class="right card">
          <div class="time_box flex-rowc">
            <div class="year">{{ date.year }}年</div>
            <div class="month_day">{{ date.month }}月{{ date.day }}日</div>
            <div class="week">{{ date.week }}</div>
          </div>
          <div class="done_box flex-rowc" @click="handleGo">待办事项提示</div>
        </div> -->
      </div>
      <!-- <div class="item card flex-between">
        <div class="left flex-rowc" @click="handleGo">
          <img src="../assets/images/edit_icon.png" />
          <div class="fontSize-mainColor-lg">工作日志</div>
        </div>
        <div class="isComplete">本日未填写</div>
      </div> -->
    </div>

    <!-- 提示 -->
    <van-overlay :show="isShow" @click="isShow = false">
      <div class="popup_wrap">
        <div class="main">
          <h1>操作权限提示！</h1>
          <div class="txt" @click="handleGo(2)">
            <p>
              请先点击 <span>“这里”</span> <br />
              创建或加入企业/团队
            </p>
            <!-- <p @click="handleGo(2)">
              点击 <span>“这里”</span> 查找并加入企业/团队
            </p> -->
            <p @click="handleGo(3)">
              或进入 <span>“我的”</span> 面板 <br />
              进行更多操作
            </p>
          </div>
          <div class="btn" @click="isShow = false">知道了</div>
        </div>
        <div class="close" @click="isShow = false">
          <i class="iconfont icon-jujueweituo"></i>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
export default {
  name: "home",
  data() {
    return {
      isShow: false,
      date: {
        year: "",
        month: "",
        day: "",
        week: "",
        year_month_day: "",
      },
    };
  },
  created() {
    this.getTime();
  },
  methods: {
    getTime() {
      var date = new Date();
      this.date.year = date.getFullYear(); //得到当前年份
      this.date.month = this.editTime(date.getMonth() + 1); //得到当前月份
      this.date.day = this.editTime(date.getDate()); //得到当前几号
      this.date.week = this.getWeek(date.getDay());
    },
    editTime(i) {
      if (i < 10) {
        i = "0" + i;
      }
      return i;
    },
    getWeek(weeks) {
      var week;
      switch (weeks) {
        case 0:
          week = "星期日";
          break;
        case 1:
          week = "星期一";
          break;
        case 2:
          week = "星期二";
          break;
        case 3:
          week = "星期三";
          break;
        case 4:
          week = "星期四";
          break;
        case 5:
          week = "星期五";
          break;
        case 6:
          week = "星期六";
          break;
      }
      return week;
    },

    handleNavBar(id) {
      if (id == 1) {
        this.$router.push("/home");
      } else {
        this.$toast("即将开放");
      }
    },

    handleGo(id) {
      let userInfo = this.$store.state.USERINFO;
      if (id == "1") {
        if (userInfo.qy && userInfo.qy.checkstate == "已通过") {
          this.$router.push("/businessCenter");
        } else {
          this.isShow = true;
        }
      } else if (id == 2) {
        this.$router.push("/companyIndex");
      } else if (id == 3) {
        this.$router.push("/mine");
      } else {
        this.$toast("即将开放");
      }
    },
  },
};
</script>
<style lang='less' scoped>
.homePage {
  .hot_wrapper {
    padding: 59px 52px 52px;
    position: relative;
    &::before {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      // background: url(../assets/images/hot_new_icon.png) no-repeat left;
      background-size: cover;
      width: 62px;
      height: 62px;
      display: inline-block;
      content: "";
    }
    h1 {
      font-size: 22px;
      color: #1e1e1e;
    }
    p {
      font-size: 20px;
      color: #1e1e1e;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }
  .hot_wrapper_new {
    width: calc(100% - 70px);
    margin-left: 70px;
  }
  .card_list {
    // padding: 0 45px;
    .card {
      flex-shrink: 0;
      width: calc((100% - 20px) / 2);
       height: 230px;
       position: relative;
    }
    // .left .card {
    //   width: 370px;
    //   height: 230px;
    //   &:first-child {
    //     margin-bottom: 20px;
    //   }
    // }
    img {
      margin: 0;
      margin-right: 34px;
      width: 56px;
    }
    .right {
      &.card {
        width: 270px;
        height: 480px;
        padding: 25px 20px;
        box-sizing: border-box;
      }
      .time_box {
        border: 1px solid rgba(173, 173, 173, 0.39);
        border-radius: 30px;
        height: 260px;
        flex-flow: column wrap;
        color: #000;
        font-size: 28px;
        .year {
          font-size: 22px;
        }
        .month_day {
          margin: 20px auto 30px;
        }
      }
      .done_box {
        border: 1px solid rgba(173, 173, 173, 0.39);
        border-radius: 30px;
        height: 90px;
        margin-top: 32px;
        font-size: 26px;
        color: #000;
      }
    }
    .item {
      &.card {
        width: 100%;
        height: 130px;
        margin-top: 20px;
      }
      &:last-child {
        padding: 0 50px;
        // padding: 0 61px 0 80px;
        box-sizing: border-box;
        img {
          width: 58px;
        }
      }
    }
  }
  .isComplete {
    font-size: 22px;
    color: #eb1b3d;
    position: absolute;
    right: 55px;
    bottom: 50px;
  }

  .popup_wrap {
    position: fixed;
    top: 45%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: #fff;
    width: 550px;
    height: 600px;
    font-size: 26px;
    color: #000000;
    text-align: center;
    padding: 70px 0 80px;
    box-sizing: border-box;
    h1 {
      font-size: 36px;
      margin-bottom: 75px;
    }
    p {
      font-size: 30px;
      line-height: 36px;
      span {
        color: #3600ff;
        font-weight: bold;
      }
      &:nth-child(2) {
        margin: 65px auto 60px;
      }
    }
    .btn {
      width: 166px;
      height: 56px;
      border-radius: 45px;
      background: #fff;
      border: 1px solid #969696;
      text-align: center;
      line-height: 56px;
      margin: 83px auto 0;
    }
    .close {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: -100px;
      .iconfont {
        font-size: 60px;
        color: #fff;
      }
    }
  }
}
</style>